import { defineStore } from 'pinia';

import { useStore as useShapeStore } from './shape';
import { useStore as useProductStore } from './product';

import { px2mm } from '@/utils';

export const useStore = defineStore({
  id: 'shapeBoxSection',

  state: () => {
    return {
      isValidInput: {
        height: true,
        width: true,
        rotation: true,
      },
    };
  },
  actions: {
    setIsValidInput(whatToUpdate: string, value: boolean) {
      if (whatToUpdate === 'height') {
        this.isValidInput.height = value;
      }
      if (whatToUpdate === 'width') {
        this.isValidInput.width = value;
      }
      if (whatToUpdate === 'rotation') {
        this.isValidInput.rotation = value;
      }
    },
    resetIsValidInput() {
      this.isValidInput = {
        height: true,
        width: true,
        rotation: true,
      };
    },
  },
  getters: {
    propsData() {
      const shapeStore = useShapeStore();
      const productStore = useProductStore();
      const positionImageDpi =
        productStore.selectedPrintPosition.originalImageWebDpi;

      const activeShapeId = shapeStore.activeShapeId;
      const shapes = shapeStore.shapes;

      const current = shapes.find((s) => s.id === activeShapeId);

      let rotation = ((current?.rotation as number) * 180) / Math.PI;

      if (rotation >= -90 && rotation < 0) {
        rotation = 360 + rotation;
      }

      return {
        kind: current?.kind,
        isRoundLogo: current?.isRoundLogo,
        isVisible: activeShapeId !== '',
        width: px2mm(current?.width as number, positionImageDpi),
        height: px2mm(current?.height as number, positionImageDpi),
        rotation: rotation,
        meta: {
          title: current
            ? current.kind === 'Text'
              ? current.w2pText.text
              : current.title
            : '',
        },
      };
    },
    getIsValidInput(state) {
      return (
        state.isValidInput.height &&
        state.isValidInput.width &&
        state.isValidInput.rotation
      );
    },
  },
});
